import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {useAxios} from '../../shared/hooks/useApi'
import {NavigationAccess} from '../../shared/types/navigationAccess.types'

const QueryKey = 'equipment-status'
const PATH = '/kpi/dashboard/accessibility'
const INTERVAL_PERIOD_IN_MS = 300000

export const useNavAccessibility = (
  options?: Omit<UseQueryOptions<NavigationAccess, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const axiosInstance = useAxios()

  return useQuery<NavigationAccess, AxiosError>({
    queryKey: [QueryKey],
    queryFn: async ({signal}) => {
      const response = await axiosInstance.get<NavigationAccess>(PATH, {signal})

      return response.data
    },
    refetchInterval: INTERVAL_PERIOD_IN_MS,
    refetchOnMount: false,
    ...options
  })
}
